import { NavLink, Outlet } from "react-router"
import { useTranslation } from "react-i18next"

import { Localizations } from "../localizations/Localizations"
import { TermsAndConditions } from "../termsAndConditions/TermsAndConditions"
import { PrivacyPolicy } from "../privacy-policy/PrivacyPolicy"

import {
  useGetConfigQuery,
} from "../../app/apiSlice"

export const Root = () => {
  const { t: tCommon } = useTranslation("common")
  const { t } = useTranslation("gift_card")

  const {
    data: configData,
  } = useGetConfigQuery()

  return (
    <div className="grid grid-rows-[70px_1fr_95px] lg:grid-rows-[1fr_1fr] lg:grid-cols-[472px_1fr] h-full">
      <header className="relative lg:static flex flex-wrap lg:flex-col justify-center items-center gap-2 rounded-bl-xl lg:rounded-bl-none rounded-br-xl lg:rounded-br-none lg:rounded-tr-xl py-2 lg:pt-6 lg:pb-0 px-4 lg:px-[4.5rem] bg-[#0D0D0D] text-[#FFFFFF]">
        <NavLink className="absolute lg:static top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%] lg:translate-y-0 lg:translate-x-0 w-auto h-[50px] lg:h-[150px]"
          to="/" end
        >
          <img
            className="m-auto w-auto max-h-full"
            src={configData?.loyalty_logo_url}
            alt=""
          />
        </NavLink>
        <h1 className="hidden lg:block mt-auto lg:mb-3 w-full font-semibold text-[4rem] leading-none text-center">
          {t("niki.gift_card.display")}
        </h1>
        <div className="lg:absolute lg:top-0 lg:left-118 lg:right-0 lg:z-50 lg:pt-4 lg:px-6 ml-auto flex justify-normal items-center gap-2 bg-[#FFFFFF]">
          <Localizations />
        </div>
      </header>
      <main className="overflow-auto lg:row-span-2 flex-1 flex flex-col py-4 lg:pt-[calc(60px+1.5rem)] lg:pb-6 px-4 lg:px-6">
        <Outlet />
      </main>
      <footer className="relative lg:static flex flex-wrap lg:flex-col justify-center items-center gap-2 rounded-tl-xl lg:rounded-tl-none rounded-tr-xl lg:rounded-tr-none lg:rounded-br-xl py-2 lg:pt-0 lg:pb-6 px-4 lg:px-[4.5rem] bg-[#0D0D0D] text-[#FFFFFF]">
        <TermsAndConditions />
        <span className="lg:hidden">/</span>
        <PrivacyPolicy />
        <div className="flex-[0_0_100%] lg:flex-none lg:mt-auto text-center">
          {t("niki.gift_card.copyright")}
        </div>
        <div className="flex-[0_0_100%] lg:flex-none text-center">
          {tCommon("niki.common.app_version")} v{import.meta.env.VITE_APP_VERSION}
        </div>
      </footer>
    </div>
  )
}
